"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getCookiesObject(cookies) {
    if (cookies === void 0) { cookies = document.cookie; }
    var cookiesObject = {};
    var decodedCookies = decodeURIComponent(cookies);
    decodedCookies.split("; ").forEach(function (cookie) {
        var cookiePair = cookie.split("=");
        if (cookiePair.length > 1) {
            cookiesObject[cookiePair[0]] = cookiePair[1];
        }
    });
    return cookiesObject;
}
exports.getCookiesObject = getCookiesObject;
function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    var cookie = name + "=" + (value + expires) + "; path=/";
    document.cookie = cookie;
    return cookie;
}
exports.createCookie = createCookie;
function readCookie(name) {
    var cookies = getCookiesObject(document.cookie);
    return name in cookies ? cookies[name] : null;
}
exports.readCookie = readCookie;
function deleteCookie(name) {
    createCookie(name, "", -1);
}
exports.deleteCookie = deleteCookie;
